import React from "react";
import Navbar from "../Components/Navigation/Navbar";
import {Button, Card, Row} from "react-bootstrap";
import Impressum from "../Components/contact/impressum";
import ContactForm from "../Components/contact/form";
import '../Components/contact/contact.css';

export function ContactPage() {
    return (<>
            <Navbar/>

            <Card>
                <Card.Header>Kontakt</Card.Header>
                <ContactForm></ContactForm>
            </Card>

            <Card className="impressum">
                <Button variant="Link" href="/impressum">Impressum</Button>
            </Card>
        </>
    )
}

export default ContactPage;